<template>
	<div class="buy-goods-list">
		<!-- 顶部提示 -->
		<DcNotify v-model="showNotify" type="warning" class="notify-top">选中相应商品后左滑然后点击删除即可完成删除操作!</DcNotify>
		<!-- 公司列表 -->
		<div v-for="(sub, index) in props.lists" :key="'list' + index">
			<div class="main-list" :class="{ invalidSign: sub.invalidSign === 1 }">
				<!-- 公司头 -->
				<div class="basic">
					<div class="title-box">
						<van-checkbox icon-size="1.5rem" v-model="sub.checked" :disabled="sub.invalidSign === 1" @click="handleSelectWebSite(sub)" />
						<div class="tag-btn third" v-if="sub.companyCode < 0">三方</div>
						<div class="tag-btn self" v-else>自营</div>
						<div @click="goToWebsite(sub)" class="title">{{ sub.companyName }}</div>
						<i style="color: #c4c4c4; font-size: 12px" class="iconfont icon-maijia_youjin"></i>
					</div>
					<div class="tips">
						<FontTag color="#F24949" v-if="isShowCoupon(sub)" @click="chooseCoupon(sub)">券</FontTag>
						<FontTag color="#f7b500" v-if="sub.list.some(item => item.purchaseZeroProductList && !!item.purchaseZeroProductList.length)">
							买赠
						</FontTag>
					</div>
				</div>

				<!-- 商品列表 -->
				<div v-for="(item, itemIndex) in sub.list" :key="'sublist' + itemIndex">
					<van-swipe-cell :name="getItemKey(item)">
						<div class="list" :class="{ last: itemIndex === sub.list.length - 1, invalidSign: item.invalidSign === 1 }">
							<van-checkbox
								icon-size="1.5rem"
								v-model="item.checked"
								:disabled="item.invalidSign === 1"
								@click="handleSelectGoods(sub, item)"
							/>

							<div class="image-section">
								<NuxtImg
									@click="toProductDetail(item)"
									style="border-radius: 4px"
									:src="item.imageUrl || '/staticSeo/images/placeholder.png'"
									:alt="item.productName"
									width="106"
									height="106"
									format="webp"
									class="product-img"
									@error="handleImageError"
								/>

								<div class="add-rp" v-if="item.frequentPurchaseSign != 1" @click="addPurchaseList(item)">
									加入常购
									<i
										class="iconfont icon-plus-circle-fill"
										:style="{ color: item.invalidSign === 1 ? '#c9cdd4' : '#23c343', fontSize: '1rem' }"
									></i>
								</div>

								<div class="invalid" v-if="item.invalidSign === 1">失效</div>
							</div>

							<div class="list-wrap">
								<div class="goods-title ellipsis" @click="toProductDetail(item)">{{ item.productName }}</div>

								<div class="goods-info" @click="toProductDetail(item)">
									<ExpandableText :dt="getStr('规格:', item.optionStr, item.materialCode)" :enable-button="false" />
									<ExpandableText :dt="getStr('', item.manufacturer, item.measuringUnitStr)" :enable-button="false" />
								</div>

								<div class="flex price-tag rel">
									<div>
										<ShowAmount :price="formatItemPrice(item)" />
										<div
											class="area-name"
											v-if="item.areaName && sub.list.filter(row => row.productId === item.productId).length > 1"
										>
											【{{ item.areaName }}】
										</div>
									</div>

									<van-stepper
										class="step-number"
										v-model="item.quantity"
										:min="getMinQuantity(item)"
										:step="getStepQuantity(item)"
										:disabled="item.invalidSign === 1"
										@change="changeVal(item)"
										@blur="changeVal(item)"
									/>

									<div class="font10 num-tag" v-if="item.ippMiniPurchaseNum && item.ippStatus === 101">
										起订数量{{ item.ippMiniPurchaseNum }},按{{ item.ippPurchaseMultiple }}倍数新增
									</div>
								</div>

								<div v-if="item.ippMiniPurchaseNum && item.ippStatus === 101" style="height: 4px"></div>

								<!-- 赠品列表 -->
								<template v-if="item.purchaseZeroProductList">
									<div
										v-for="(purchase, i) in getValidGifts(item)"
										:key="'purchase' + i"
										class="gift"
										:style="item.ippMiniPurchaseNum && item.ippStatus === 101 ? 'margin-top: 0.4rem;' : ''"
										@click="toProductDetail(purchase, sub.companyId)"
									>
										<span>[赠品]</span>
										<span class="ellipsis" style="flex: 1">{{ purchase.productName }} x{{ purchase.giftQuantity }}</span>
									</div>
								</template>
							</div>
						</div>

						<!-- 滑动操作按钮 -->
						<template #right>
							<div class="swipe-buttons">
								<button v-if="item.isCollected == 0" class="swipe-btn favorite-btn" @click="toggleFavor(item, true)">收藏</button>
								<button v-else class="swipe-btn unfavorite-btn" @click="toggleFavor(item, false)">取消收藏</button>
								<button class="swipe-btn delete-btn" @click="deleteItem(item)">删除</button>
							</div>
						</template>
					</van-swipe-cell>
				</div>
			</div>
		</div>

		<!-- 猜你喜欢 -->
		<GuessLike
			v-if="recommendList.length > 0"
			:dataList="recommendList"
			fromPage="购物车"
			@click="clickGuessLike"
			@addCartSuccess="handleGuessLikeAddCartSuccess"
		/>

		<!-- 选择优惠券弹窗 -->
		<ChooseCoupon ref="chooseCoupon" @queryList="handleQueryList" @changeCoupon="handleChangeCoupon" />
	</div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick, onUnmounted } from 'vue';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash-es';
import { showToast, showDialog } from 'vant';
import { removeBuyerCart, getShoppingCartActivity, editCartList } from '@/api/buyCar.js';
import { addOftenList } from '@/api/buyCar.js';
import ChooseCoupon from './ChooseCoupon.vue';
import { addFavoriteList, removeFavorite } from '@/api/goods.js';
import GuessLike from '@/components/GuessLike.vue';
import ExpandableText from '@/components/ExpandableText.vue';
import ShowAmount from '@/components/ShowAmount.vue';
import FontTag from '@/components/FontTag.vue';
import DcNotify from '@/components/DcNotify.vue';
import { useAnalytics } from '@/composables/useAnalytics';
import { useCartStore } from '@/stores/cart';
import { mobileProductDetailPath } from '@/utils/link/mobileProductDetail';
import { getCooperationListPriceLabel, getPrice } from '@/utils/productPrice';

const { trackEvent } = useAnalytics();
const { formatPrice } = usePriceFormat();

/** 购物车行展示价：合作价固定文案；否则参考价 + 控销走 formatPrice（与列表 ShowAmount 一致） */
const formatItemPrice = item => {
	const coop = getCooperationListPriceLabel(item);
	if (coop != null) return coop;
	const itemPrice = getPrice(item);
	const controlSales = item.isControlSales ?? item.iscontrolsales;
	const isControlSalesProduct = controlSales !== undefined && controlSales !== null && controlSales !== '' && Number(controlSales) === 1;
	if (!isControlSalesProduct) {
		return formatPrice(itemPrice, 2);
	}
	const isSeeNoBuy = item.isSeeNoBuy ?? item.isseenobuy;
	return formatPrice(itemPrice, 2, 1, isSeeNoBuy);
};

const route = useRoute();
const cartStore = useCartStore();

const props = defineProps({
	lists: {
		type: Array,
		default: () => [],
	},
	recommendList: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['queryList', 'changeWebSite', 'changeGoods', 'getCartPurchaseZero']);

const showNotify = ref(true);
const notifyRef = ref(null);
const chooseCouponRef = ref(null);
const cacheProductList = ref([]);

// 处理图片错误
const handleImageError = e => {
	e.target.src = '/staticSeo/images/placeholder.png';
};

// 判断是否有赠品
const hasGiftProduct = sub => {
	return sub.list.some(item => item.purchaseZeroProductList && item.purchaseZeroProductList.length > 0);
};

// 获取有效赠品
const getValidGifts = item => {
	if (!item.purchaseZeroProductList) return [];
	return item.purchaseZeroProductList.filter(purchase => {
		return item.quantity >= (purchase.arriveNum || 0);
	});
};

// 获取最小数量
const getMinQuantity = item => {
	if (item.ippStatus === 101 && item.ippMiniPurchaseNum) {
		return item.ippMiniPurchaseNum;
	}
	return 1;
};

// 获取步长
const getStepQuantity = item => {
	if (item.ippStatus === 101 && item.ippPurchaseMultiple) {
		return item.ippPurchaseMultiple;
	}
	return 1;
};

// 获取商品唯一标识
const getItemKey = item => {
	return `${item.companyId}_${item.productId}_${item.buyerCartId}`;
};

// 选择站点
const handleSelectWebSite = webSite => {
	emit('changeWebSite', webSite);
};

// 选择商品
const handleSelectGoods = (webSite, goods) => {
	if (goods.invalidSign != 1) {
		emit('changeGoods', webSite, goods);
	}
};

// 跳转网站
const goToWebsite = website => {
	const companyId = website?.companyId || website?.companyid;
	if (!companyId) {
		showToast({ message: '站点信息异常', icon: 'none' });
		return;
	}
	navigateTo(`/${companyId}`);
};

// 跳转商品详情
const toProductDetail = (item, fallbackCompanyId) => {
	const productId = item?.productId || item?.productid;
	const companyId = item?.companyId || item?.mobileCompanyId || fallbackCompanyId;
	if (!productId || !companyId) return;
	const path = mobileProductDetailPath(companyId, productId);
	if (path) navigateTo(path);
};

// 数量变化
const changeVal = item => {
	if (item.ippStatus === 101 && item.ippMiniPurchaseNum) {
		if (item.quantity < item.ippMiniPurchaseNum) {
			item.quantity = item.ippMiniPurchaseNum;
		} else {
			if (item.ippMiniPurchaseNum) {
				const remainder = (item.quantity - item.ippMiniPurchaseNum) % item.ippPurchaseMultiple;
				if (remainder > 0) {
					const beis = Math.floor((item.quantity - item.ippMiniPurchaseNum) / item.ippPurchaseMultiple);
					item.quantity = item.ippMiniPurchaseNum + item.ippPurchaseMultiple * beis;
				}
			}
		}
	}

	if (!item.quantity) return;

	emit('getCartPurchaseZero', props.lists);

	editCartList({
		buyerCartId: item.buyerCartId,
		modifyQuantity: item.quantity,
		subtotal: item.quantity * item.price,
	});
};

// 选择优惠券
const chooseCoupon = item => {
	let params = {
		companyCode: item.companyCode,
		orderProductList: item.list
			.filter(list => list.invalidSign !== 1)
			.map(product => ({
				productId: product.productId,
				productCode: product.productCode,
				productPrice: product.price,
				purchaseQuantity: product.quantity,
				agreementPriceId: product.agreementPriceId,
				areaName: product.areaName,
				imageUrl: product.imageUrl,
				checked: false,
			})),
	};

	getShoppingCartActivity(params)
		.then(res => {
			if (res.code == 200 && res.data) {
				chooseCouponRef.value.open(item, res.data.couponActivityVo || []);
			}
		})
		.catch(err => {
			console.error('获取优惠券失败:', err);
		});
};

// 删除商品
const deleteItem = item => {
	showDialog({
		title: '提示',
		message: '确认要删除该商品吗？',
		confirmButtonText: '确定',
		cancelButtonText: '取消',
	})
		.then(() => {
			removeBuyerCart({
				buyerCartIdList: [item.buyerCartId],
			})
				.then(res => {
					if (res.code == 200) {
						showToast({
							message: '删除成功',
							icon: 'none',
							duration: 2000,
						});
						emit('queryList');
					} else {
						showToast({
							message: res.message || '删除失败',
							icon: 'none',
						});
					}
				})
				.catch(err => {
					showToast({
						message: '删除失败',
						icon: 'none',
					});
				});
		})
		.catch(() => {
			// 用户取消
		});
};

// 收藏/取消收藏
const toggleFavor = (item, isFavor) => {
	const param = {
		productId: item.productId,
	};

	if (isFavor) {
		addFavoriteList(param)
			.then(res => {
				if (res.code === '200') {
					item.isCollected = 1;
					showToast({ title: '收藏成功', icon: 'success' });
				}
			})
			.catch(() => {
				item.isCollected = 1;
			});
	} else {
		removeFavorite(param)
			.then(res => {
				if (res.code === '200') {
					item.isCollected = 0;
					showToast({ title: '取消收藏成功', icon: 'success' });
				}
			})
			.catch(() => {
				item.isCollected = 0;
			});
	}
};

// 添加到常购清单
const addPurchaseList = item => {
	let params = {
		buyerCartId: item.buyerCartId,
	};

	addOftenList(params)
		.then(res => {
			if (res.code === '200') {
				showToast({
					message: '已成功设为常购',
					icon: 'none',
					duration: 3000,
				});
				item.frequentPurchaseSign = 1;
			} else if (res.code === '1076') {
				showToast({ title: res.message, icon: 'none' });
			} else {
				showToast({ title: res.message, icon: 'none' });
			}
		})
		.catch(() => {
			showToast({ title: '操作失败', icon: 'none' });
		});
};

const clickGuessLike = productInfo => {
	trackEvent({
		companyCode: productInfo.companyCode,
		companyName: productInfo.companyName,
		module: '购物车',
		eventCode: 'cart_page_click',
		eventName: '购物车点击',
		attrCode: 'button_name',
		attrName: '猜你喜欢',
		ext1: productInfo.productCode,
		ext2: productInfo.productName,
	});
};

const handleGuessLikeAddCartSuccess = async () => {
	emit('queryList');
	await cartStore.updateCartCount();
};

// 查询列表回调
const handleQueryList = () => {
	emit('queryList');
};

// 优惠券变化回调
const handleChangeCoupon = (sub, ids) => {
	chooseCoupon(sub, ids);
};

// 获取字符串
const getStr = (title = '规格:', specifications, materialCode, manufacturer, measuringUnit) => {
	let str = '';
	if (specifications) {
		str += title + specifications;
	}
	if (materialCode) {
		str += ' | ' + materialCode;
	}
	if (manufacturer) {
		str += ' | ' + manufacturer;
	}
	if (measuringUnit) {
		str += ' | 单位:' + measuringUnit;
	}
	return str;
};

// 判断是否显示优惠券
const isShowCoupon = sub => {
	return sub.couponActivityVo && sub.couponActivityVo.length > 0;
};

// 全选/取消全选
const chooseAll = val => {
	props.lists.forEach(item => {
		item.checked = val;
		item.list.forEach(list => {
			// 排除失效商品
			if (list.invalidSign !== 1) {
				list.checked = val;
			}
		});
	});
};

// 重置顶部位置
const resetTop = () => {
	nextTick(() => {
		if (notifyRef.value) {
			notifyRef.value.scrollIntoView({ behavior: 'smooth' });
		}
	});
};

onMounted(() => {
	showNotify.value = true;
});

// 导出方法给父组件
defineExpose({
	chooseAll,
	resetTop,
});
</script>

<style scoped lang="scss">
.buy-goods-list {
	background-color: #f5f5f5;
	height: calc(100vh - 102px);
	overflow-y: auto;
}

.notify-top {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
}

.main-list {
	position: relative;
	margin-bottom: 8px;
	background-color: #fff;

	&.invalidSign {
		opacity: 0.7;
	}

	.tips {
		display: flex;
		gap: 0.42rem;
	}

	.basic {
		padding: 0.58rem 1rem 0.58rem 0.97rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 4px;

		.title-box {
			display: flex;
			align-items: center;
			gap: 0.42rem;
			padding: 4px 0;

			.tag-btn {
				padding: 0 0.6rem;
				margin-left: 0.2rem;
				line-height: 1.5rem;
				font-size: 0.83rem;
				color: #fff;
				border-radius: 0.3rem;

				&.self {
					background-color: #798bf2;
				}

				&.third {
					background-color: #72ce46;
				}
			}

			.title {
				font-family: 思源黑体;
				font-size: 13px;
				font-weight: normal;
				line-height: 1.33rem;
				letter-spacing: 0px;
				color: #333333;
			}

			i {
				color: #c4c4c4;
				font-size: 12px;
			}
		}
	}

	.list {
		width: 100%;
		display: flex;
		background: #ffffff;
		padding: 0 1rem;
		gap: 0.67rem;
		margin-bottom: 12px;

		&.invalidSign {
			opacity: 0.7; // 失效商品整体变暗，参考 DC 项目
		}

		.list-wrap {
			flex: 1;
			display: flex;
			flex-direction: column;
			width: calc(100% - 12.5rem);

			.goods-title {
				width: 100%;
				font-family: Source Han Sans;
				font-size: 13px;
				font-weight: normal;
				line-height: 1.5rem;
				color: #333;
				font-weight: 500;
				margin-bottom: 4px;
			}

			.goods-info {
				font-family: Source Han Sans;
				font-size: 0.83rem;
				font-weight: normal;
				color: #999999;

				.info-line {
					line-height: 1.4rem;
				}
			}

			.price-tag {
				padding: 0.2rem 0;
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				position: relative;
				min-height: 3rem;

				> div:first-child {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					gap: 2px;
				}
			}

			.price {
				font-size: 1.17rem;
				font-weight: 400;
				color: #ed2121;
			}

			.cooperation-price {
				font-size: 1.17rem;
				font-weight: 400;
				color: #ed2121;
				line-height: 1.5rem;
			}
		}

		.image-section {
			display: flex;
			flex-direction: column;
			position: relative;

			.product-img {
				width: 6.6rem;
				height: 6.6rem;
				object-fit: cover;
				border-radius: 4px;
			}

			.add-rp {
				width: 4.67rem;
				display: flex;
				align-items: center;
				justify-content: space-evenly;
				border-radius: 0.25rem;
				background: #ebfff0;
				border: 0.083rem solid #7be188;
				font-family: Source Han Sans;
				font-size: 0.75rem;
				font-weight: normal;
				line-height: 1rem;
				color: #0eab32;
				margin-top: -1.25rem;
				margin-left: 0.33rem;
				z-index: 1;

				i {
					color: #23c343;
					font-size: 1rem !important;
				}
			}

			.invalid {
				width: 3.25rem;
				height: 3.25rem;
				line-height: 4rem;
				font-size: 1rem;
				background: rgba(0, 0, 0, 0.6);
				border-radius: 50%;
				color: #fff;
				margin-top: -4.38rem;
				z-index: 10;
				margin-left: 50%;
				transform: translateX(-50%);
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}
}

.flex {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	&.start {
		padding: 0;
		justify-content: flex-start;
	}
}

.rel {
	position: relative;
}

.num-tag {
	position: absolute;
	right: 0;
	top: 2.2rem;
	color: #ed2121;
	font-size: 10px;
	text-align: right;
}

.area-name {
	display: block;
	font-size: 1rem;
	line-height: 1rem;
	color: #999;
}

.gift {
	display: flex;
	align-items: center;
	padding: 0.3rem 0;
	font-size: 0.83rem;
	color: #999;

	span:first-child {
		color: #f7b500;
		margin-right: 0.42rem;
	}
}

// 滑动按钮样式
.swipe-buttons {
	width: 160px;
	display: flex;
	justify-content: flex-end;
	height: 100%;

	.swipe-btn {
		height: 100%;
		border: none;
		outline: none;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s;
		padding: 0 8px;

		&.favorite-btn {
			background-color: #3852ba;
			color: #fff;
		}

		&.unfavorite-btn {
			background-color: #3852ba;
			color: #fff;
		}

		&.delete-btn {
			background-color: #f56067;
			color: #fff;
		}

		&:active {
			opacity: 0.8;
		}
	}
}
:deep(.van-swipe-cell__right) {
	right: -4px;
}
</style>
